var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContainerrr1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15C5.58333 15 3.91319 14.3646 2.48958 13.0938C1.06597 11.8229 0.25 10.2361 0.0416667 8.33333H1.75C1.94444 9.77778 2.58681 10.9722 3.67708 11.9167C4.76736 12.8611 6.04167 13.3333 7.5 13.3333C9.125 13.3333 10.5035 12.7674 11.6354 11.6354C12.7674 10.5035 13.3333 9.125 13.3333 7.5C13.3333 5.875 12.7674 4.49653 11.6354 3.36458C10.5035 2.23264 9.125 1.66667 7.5 1.66667C6.54167 1.66667 5.64583 1.88889 4.8125 2.33333C3.97917 2.77778 3.27778 3.38889 2.70833 4.16667H5V5.83333H0V0.833333H1.66667V2.79167C2.375 1.90278 3.23958 1.21528 4.26042 0.729167C5.28125 0.243056 6.36111 0 7.5 0C8.54167 0 9.51736 0.197917 10.4271 0.59375C11.3368 0.989583 12.1285 1.52431 12.8021 2.19792C13.4757 2.87153 14.0104 3.66319 14.4062 4.57292C14.8021 5.48264 15 6.45833 15 7.5C15 8.54167 14.8021 9.51736 14.4062 10.4271C14.0104 11.3368 13.4757 12.1285 12.8021 12.8021C12.1285 13.4757 11.3368 14.0104 10.4271 14.4062C9.51736 14.8021 8.54167 15 7.5 15ZM9.83333 11L6.66667 7.83333V3.33333H8.33333V7.16667L11 9.83333L9.83333 11Z",
    fill: "#2E7D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainerrr1);
export default __webpack_public_path__ + "static/media/Containerrr (1).f66c921907c23c54aa94e272f29fd281.svg";
export { ForwardRef as ReactComponent };